import(/* webpackMode: "eager" */ "/codebuild/output/src2890004161/src/src/app/error.tsx");
